module.exports = __webpack_public_path__ + "img/agenda.854fd3a8.svg";